<div
  echarts
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
  (chartMouseOver)="onChartMouseOver($event)"
  (chartMouseOut)="onChartMouseOut($event)"
  class="scatter-plot-chart"
></div>
